import React from "react";
import './screen.css'
import {ContainerComponent} from "../container/ContainerComponent";

export function ScreenComponent({children}) {
    return (
        <ContainerComponent>
            <main className="screen">
                {children}
            </main>
        </ContainerComponent>
    )
}
